import { render, staticRenderFns } from "./DistModal.vue?vue&type=template&id=4ead5369&"
import script from "./DistModal.vue?vue&type=script&lang=js&"
export * from "./DistModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports